<!-- 组件说明 -->
<template>
  <div class="">
    <div class="topbar">
      <div class="top-cate" @click="selectTop('joint')">
        <div :class="['top-content', type === 'joint' ? 'isSelect' : '']">
          合资待审核
        </div>
        <img
          :class="['top-line', type !== 'joint' ? 'isSelect' : '']"
          src="~/common/images/recommend/underline.png"
        />
      </div>
      <div class="line"></div>
      <div class="top-cate" @click="selectTop('owner')">
        <div :class="['top-content', type === 'owner' ? 'isSelect' : '']">
          业主带访
        </div>
        <img
          :class="['top-line', type !== 'owner' ? 'isSelect' : '']"
          src="~/common/images/recommend/underline.png"
        />
      </div>
    </div>
    <!-- 合资待审核列表 -->
    <Joint
      v-if="type === 'joint'"
      :projectCode="projectCode"
      :orgCode="orgCode"
    />
    <!-- 业主带访列表 -->
    <Owner
      v-if="type === 'owner'"
      ref="owner"
      :projectCode="projectCode"
      :orgCode="orgCode"
    />
  </div>
</template>

<script>
import Joint from "./PendingComponent/Joint";
import Owner from "./PendingComponent/Owner";
export default {
  props: {
    projectCode: {
      type: String,
    },
    orgCode: {
      type: String,
    },
  },
  components: { Joint, Owner },
  data() {
    return {
      type: "joint", //"joint"合资待审核；"owner"业主带访
    };
  },
  computed: {},
  methods: {
    selectTop(type) {
      // 点击业主带访，退出回收站页面
      if (this.type === "owner" && type === "owner") {
        this.$refs.owner.isRecycleBin = false;
      }
      // 切换列表
      this.type = type;
    },
  },
};
</script>

<style lang="scss" scoped>
.topbar {
  display: flex;
  justify-content: space-around;
  align-items: center;
  .line {
    width: 2px;
    height: 60px;
    background: #eaeaea;
    border-radius: 1px;
  }
  .top-cate {
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 82px;
    width: 370px;
    .top-content {
      height: 68px;
      line-height: 68px;
      font-size: 28px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #575757;
      &.isSelect {
        color: #0d9869;
      }
    }
    .top-line {
      width: 50px;
      height: 14px;
      &.isSelect {
        display: none;
      }
    }
  }
}
</style>
